<script lang="ts">
  const onJumpUrl = () => {
    location.href =  'https://iwan.qq.com/h/privilege?hidetitlebar=1&ovscroll=0&iOSUseWKWebView=1&reportParams=iwan_active_rpk&ADTAG2=txsp.jx-1.rk-1';
  };
</script>

<div role="button" tabindex="0" class="iwan-honor-link" on:keyup={() => {}} on:click={onJumpUrl}>
  <span>绑定爱玩荣耀，即享</span>
  <span class="iwan-honor-link-highlight">独家权益</span>
  <img
    class="iwan-honor-link-img"
    src="https://puui.qpic.cn/iwan_cloud/1/5ddd565a5da9812e6805fb3ca6a0c1e1/q45"
    alt=""
  />
</div>

<style lang="scss">
  .iwan-honor-link {
    color: #808080ff;
    font-size: 12px;
    font-family: 'PingFang SC';
    text-align: center;
    margin-top: 5px;
    display: flex;
    display: flex;
    justify-content: center;
    align-items: center;
    &-highlight {
      color: #ce803aff;
      margin-right: 6px;
    }
    &-img {
      width: 14px;
      height: 14px;
    }
  }
</style>
